import { createRouter, createWebHistory } from 'vue-router'
import generatedRoutes from '~pages'
import { setupLayouts } from 'virtual:generated-layouts'
import { APPLICATION_SUBPATH } from '@/config'

const router = createRouter({
  history: createWebHistory(APPLICATION_SUBPATH ? APPLICATION_SUBPATH : undefined),
  routes: setupLayouts(generatedRoutes),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
